export const selectOptionsSorter = (a, b) => {
  a = a.label.toLowerCase();
  b = b.label.toLowerCase();

  if (a < b) return -1;
  if (a > b) return 1;

  return 0;
};

const filterArchived = (options) => {
  return options.filter((o) => !o.isArchived);
};

const getId = (o) => {
  return o.id;
};

export const ensureSelectValue = ({ config, value }) => {
  let options = filterArchived(config.options);
  options.sort(selectOptionsSorter);

  const ids = options.map(getId);

  if (config.multiSelect) {
    return (value ?? []).filter((id) => ids.includes(id));
  }

  return ids.includes(value) ? value : undefined;
};

export const displaySelectValue = ({ config, value }) => {
  // TODO: filter archived options at the endpoint,
  // so we don't have to do it everywhere
  // - clean up archived options and the values
  // on any options, on a cron
  // - can have tasks to double check things are
  // cleaned up

  const { options = [] } = config;

  if (config.multiSelect) {
    let result = options.filter(
      (o) => !o.isArchived && o.label && value?.includes(o.id)
    );

    result.sort(selectOptionsSorter);

    return result.map((o) => o.label).join(", ");
  }

  return (
    options.filter((o) => !o.isArchived).find((o) => o.id === value)?.label ??
    ""
  );
};
